import { headerAndFooter, constants as config } from '@config';

const DesignFacade = require('../../../../facade/design/design');

const BaseView = require('./abstract/base');

module.exports = BaseView.extend({
  template: require('./templates/library-text.hbs'),

  addElement: function (elementData) {
    const selectedElements = [...document.querySelectorAll('#svgcontent .element.textarea.selected')];

    if (selectedElements.length) {
      for (const element of selectedElements) {
        DesignFacade.set(element.id, { heading: this.heading });
      }
    } else {
      const baseSize = Math.min(this.canvas.contentW, this.canvas.contentH);
      DesignFacade.create('text', Object.assign({
        heading: this.heading,
        content: this.content,
        font: {
          family: this.family,
          size: Math.round(baseSize * config.tableOfContents.defaultHeadingStyle[this.heading].size),
          weight: config.tableOfContents.defaultHeadingStyle[this.heading].fontWeight
        }
      }, elementData));
    }
  },

  initialize: function ({ heading }) {
    this.heading = heading;
    this.content = `Heading ${heading}`;
    this.family = 'Nunito'; // TODO

    BaseView.prototype.initialize.call(this);
  },

  render: function () {
    this.$el.html(this.template({
      supports_options: false,
      data: {
        ...headerAndFooter.headingStyle,
        default_content: this.content,
        family: this.family,
        font_size: headerAndFooter.headingFontSizes[this.heading]
      }
    }));

    this.$draggable = this.$el.find('.draggable');
  }
});
